import { useTranslation } from 'react-i18next';
import { Card, Button } from '@features/ui';
import { useEffect, useState } from 'react';
import {
  getTerms,
  TermAndConditionGroupByTypeRead,
} from '@src/services/termsAndConditions';
import { TSectionCollapsible } from '@src/types';
import { QuestionIcon } from '@features/ui/icons';
import { KnowledgeBaseSection } from '@src/features/admin/knowledgebase/knowledgeBaseSection';
import { useNavigate } from 'react-router-dom';

export const TermsAndConditionsPage = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [sections, setSections] = useState<
    { groupName: string; type_id: number; items: TSectionCollapsible[] }[]
  >([]);

  useEffect(() => {
    let mounted = true;

    const load = async () => {
      try {
        const res = await getTerms();
        const groups: TermAndConditionGroupByTypeRead[] = res.data ?? [];

        // Backend already returns data grouped and sorted by type.sort_order
        const mapped = groups.map((g) => ({
          groupName: g.name,
          type_id: g.type_id,
          items: g.terms.map((it) => ({
            id: String(it.id),
            title: it.name,
            description: it.content ?? '',
          })),
        }));

        if (mounted) setSections(mapped);
      } catch {
        console.error('Failed to load terms');
      }
    };

    load();

    return () => {
      mounted = false;
    };
  }, []);

  const handleCreate = () => navigate('/admin/terms-and-conditions/create');

  return (
    <div>
      <div
        className={
          'flex lg:flex-row flex-col justify-between lg:items-center gap-2 lg:mb-4.5 mb-2'
        }
      >
        <h1 className={'text-[23px]'}>{t('term.terms&Conditions')}</h1>
        <Button
          className={'w-fit'}
          size={'sm'}
          variant={'lime'}
          onClick={handleCreate}
        >
          Create New Article
        </Button>
      </div>
      <Card className={'gap-y-5'}>
        {sections.length === 0 ? (
          <p className="text-gray-400 text-sm py-4">No terms found.</p>
        ) : (
          sections.map((s) => (
            <KnowledgeBaseSection
              key={s.type_id}
              data={s.items}
              iconComponent={<QuestionIcon />}
              title={s.groupName}
              onClick={(id) => navigate(`/admin/terms-and-conditions/${id}`)}
            />
          ))
        )}
      </Card>
    </div>
  );
};
